/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Before_1Inputs */

const en_landing_before_1 = /** @type {(inputs: Landing_Before_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Same generic resume for every job`)
};

const de_landing_before_1 = /** @type {(inputs: Landing_Before_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gleicher generischer Lebenslauf fuer jeden Job`)
};

const fr_landing_before_1 = /** @type {(inputs: Landing_Before_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le même CV générique pour chaque emploi`)
};

const es_landing_before_1 = /** @type {(inputs: Landing_Before_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El mismo currículum genérico para cada empleo`)
};

const it_landing_before_1 = /** @type {(inputs: Landing_Before_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stesso curriculum generico per ogni lavoro`)
};

const nl_landing_before_1 = /** @type {(inputs: Landing_Before_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hetzelfde generieke CV voor elke baan`)
};

const pl_landing_before_1 = /** @type {(inputs: Landing_Before_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To samo ogólne CV na każdą ofertę`)
};

const fi_landing_before_1 = /** @type {(inputs: Landing_Before_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sama yleinen ansioluettelo jokaiseen hakemukseen`)
};

const da_landing_before_1 = /** @type {(inputs: Landing_Before_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Det samme generiske CV til hvert job`)
};

const sv_landing_before_1 = /** @type {(inputs: Landing_Before_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Samma generiska CV till varje jobb`)
};

/**
* | output |
* | --- |
* | "Same generic resume for every job" |
*
* @param {Landing_Before_1Inputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_before_1 = /** @type {((inputs?: Landing_Before_1Inputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Before_1Inputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_before_1(inputs)
	if (locale === "fr") return fr_landing_before_1(inputs)
	if (locale === "es") return es_landing_before_1(inputs)
	if (locale === "it") return it_landing_before_1(inputs)
	if (locale === "nl") return nl_landing_before_1(inputs)
	if (locale === "pl") return pl_landing_before_1(inputs)
	if (locale === "fi") return fi_landing_before_1(inputs)
	if (locale === "da") return da_landing_before_1(inputs)
	if (locale === "sv") return sv_landing_before_1(inputs)
	return en_landing_before_1(inputs)
});